import { Select } from "antd";
import { ErrorMessage } from "formik";
import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const FormWapper = styled.form`
  display: flex;
  flex-direction: row;
  width: 90%;
  margin-top: 4%;
  flex-wrap: nowrap !important;
`;

export const InputsContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  & + div {
    margin-left: 4%;
  }
`;

export const InputsLabel = styled.div`
  color: var(--neutral-color-dark-10, #272d3b);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const InputsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;

  &.error {
    > .ant-select > .ant-select-selector,
    > .ant-select > .ant-select-selector:hover {
      border-color: #ff4d4f !important;
    }

    > input {
      border-color: #ff4d4f !important;
    }
  }
`;

export const CustomSelect = styled(Select)`
  &.ant-select-disabled .ant-select-selector {
    background-color: #f5f5f5 !important;
    cursor: not-allowed;

    :hover {
      border-color: #d9d9d9 !important;
    }
  }
`;

export const CustomReactInputMask = styled(ReactInputMask)`
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  height: 32px;
  padding: 12px;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const TelephoneTypeContent = styled.div`
  width: 50%;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const TelephoneTrash = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 16px;
  width: 100%;
  height: 19px;

  > button {
    all: unset;
    width: 19px;
    height: 19px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
      cursor: not-allowed;
    }

    > span > svg,
    > svg {
      width: 19px;
      height: 19px;
    }

    &.on svg {
      color: #52c41a;
      fill: #52c41a;
    }
    &.off svg {
      color: #ccc;
      fill: #ccc;
    }
  }
`;

export const BtnPhone = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;

  position: relative;

  .bg-btn {
    width: 100%;
    height: 1px;
    background: #f0f0f0;
    position: absolute;
    top: 50%;
    left: 0;
  }
`;

export const AddButton = styled.button`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 241px;
  height: 32px;
  background: #ffffff;
  border: 1px solid var(--neutral-color-gray-6, #bfbfbf);
  box-sizing: border-box;
  box-shadow: 0px 0px 8px 15px #fff;
  border-radius: 2px;

  color: var(--neutral-color-dark-10, #272d3b);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const CustomErrorMessage = styled(ErrorMessage)`
  font-size: 12px;
  color: #ff4d4f;
`;
